import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "services/apiService";

export const fetchProjects = createAsyncThunk(
  "project/fetchProjects",
  async (apiHeaders: {
    token?: string;
    clientSlug?: string;
    locale?: string;
    clientId?: string;
  }) => {
    try {
      const response = await ApiService({
        method: "get",
        endpoint: "/client/v1/dropdown/project",
        headers: {
          Authorization: `Bearer ${apiHeaders.token}`,
        },
        apiHeaders,
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.message || "Failed to fetch projects"
        );
      } else {
        throw new Error("Failed to fetch projects");
      }
    }
  }
);
